import {
  Mitarbeiter_CreateFeiertagskontoAusgleichMutation,
  Mitarbeiter_CreateFeiertagskontoAusgleichMutationVariables,
} from '@/gql/graphql';
import { gql, TypedDocumentNode } from '@apollo/client';

export const CREATE_FEIERTAGSKONTO_KONTOAUSGLEICH: TypedDocumentNode<
  Mitarbeiter_CreateFeiertagskontoAusgleichMutation,
  Mitarbeiter_CreateFeiertagskontoAusgleichMutationVariables
> = gql`
  mutation mitarbeiter_createFeiertagskontoAusgleich(
    $input: mitarbeiter_createFeiertagskontoKontoausgleichInput!
  ) {
    mitarbeiter_createFeiertagskontoKontoausgleich(input: $input) {
      failure {
        message
      }
      success {
        art
        bemerkung
        datum
        tage
      }
    }
  }
`;
